import { render } from "./CorporationInfo.vue?vue&type=template&id=0cf28523&scoped=true&ts=true"
import script from "./CorporationInfo.vue?vue&type=script&lang=ts"
export * from "./CorporationInfo.vue?vue&type=script&lang=ts"

import "./CorporationInfo.vue?vue&type=style&index=0&id=0cf28523&scoped=true&lang=css"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf28523"]])

export default __exports__